import { useFetchBillingData } from "@sushicorp/services";
import React, { useState } from "react";

import Styles from "./ProfileBilling.styles";
import { ProfileBillingProps as Props } from "./ProfileBilling.types";
import BillingDataModal from "components/checkout/BillingDataModal/BillingDataModal";
import AddNewRecordButton from "components/global/AddNewRecordButton/AddNewRecordButton";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import Redirect from "components/global/Redirect/Redirect";
import BillingDataList from "components/profile/BillingDataList/BillingDataList";
import CONSTANTS from "config/constants";
import useAuth from "contexts/auth/auth.context.hooks";
import useI18n from "hooks/useI18n";
import { notify } from "utils/common.utils";
import { dismissErrorNotification } from "utils/notifications.utils";
import { createErrorNotification } from "utils/notifications.utils";

const { MAX_NUMBER_OF_BILLING_DATA } = CONSTANTS.CONSTRAINTS;
const { WITH_BOTTOM_SEARCH, WITH_BOTTOM_RESPONSIVE_BUTTONS } =
  CONSTANTS.FEATURE_FLAGS;

const ProfileBilling: React.FC<Props> = props => {
  const t = useI18n();
  const [openModal, setOpenModal] = useState(false);
  const auth = useAuth();
  const { isAnonymous } = auth;
  const fetchBillingData = useFetchBillingData(auth, notify);
  const { data: billingDataList } = fetchBillingData;
  const { isLoading, isError } = fetchBillingData;

  const closeHandler = () => {
    setOpenModal(false);
  };

  const validateNumberBilling = () => {
    if ((billingDataList?.length ?? 0) >= MAX_NUMBER_OF_BILLING_DATA) {
      dismissErrorNotification();
      const maxBillingError = t.errors.maxBillingLimit(
        MAX_NUMBER_OF_BILLING_DATA
      );
      createErrorNotification(maxBillingError, t.errors.overBillingLimit);
      return null;
    }
    setOpenModal(true);
  };

  if (isAnonymous) {
    return <Redirect pathname="/signin" redirect="/profile/billing" />;
  }

  return (
    <Styles
      className="ProfileBilling"
      withBottomSearch={WITH_BOTTOM_SEARCH}
      withBottomResponsiveButtons={WITH_BOTTOM_RESPONSIVE_BUTTONS}
    >
      <header className="ProfileBilling__header">
        <Navbar showBrand />
      </header>
      <main className="ProfileBilling__main">
        <div className="ProfileBilling__layout">
          <ProfileNavigation className="ProfileBilling__profile-navigation" />
          <div className="ProfileBilling__container">
            <GoBack
              className="ProfileBilling__go-back"
              title={t.common.goBack}
            />
            <div className="ProfileBilling__billing-data">
              <div className="ProfileBilling__billing-data__header">
                <h2 className="ProfileBilling__billing-data__header__title">
                  {t.billing.billingInformation}
                </h2>
                <AddNewRecordButton
                  onClick={validateNumberBilling}
                  value={t.billing.addBillingInformation}
                  mobileValue={t.common.add}
                />
                <BillingDataModal
                  showSearch={true}
                  opened={openModal}
                  onClose={closeHandler}
                  moreActions={["default"]}
                />
              </div>
              <BillingDataList
                actions={["edit", "delete", "default"]}
                isLoading={isLoading}
                isError={isError}
                billingDataList={billingDataList}
              />
            </div>
          </div>
        </div>
      </main>
      <footer className="ProfileBilling__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileBilling.defaultProps = {};

export default ProfileBilling;
